/**
 * Renders v2 or v1 of the Sessions list based on the redesign flag. Used as
 * the route component so we keep a single sidebar entry for /sessions while
 * letting QA flip between implementations from the floating DevTools toggle.
 *
 * Once v2 is the default, this file (and SessionsPageV2.jsx) become the
 * canonical SessionsPage and the v1 file gets deleted.
 */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import SessionsPage from './SessionsPage';
import SessionsPageV2 from './SessionsPageV2';

export default function SessionsPageSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? SessionsPageV2 : SessionsPage;
  return <Component {...props} />;
}
